<template>
    <el-dialog
        width="78%"
        top="5%"
        title="地图"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="driver-map-dialog"
    >
        <!-- 地图容器 -->
        <div id="mapContainer"></div>
    </el-dialog>
</template>
<script>
import DriverMap from './mapUtils/driverMap.js';
export default {
    name: 'mapDialog',
    components: {},
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            map: null
        };
    },
    methods: {
        initMap () {
            this.$nextTick(() => {
                this.map = new DriverMap('mapContainer', this.rowData);
            });
        },
        handleClose () {
            this.$emit('handleClose', 'mapDialog');
        }
    },
    mounted () {
        this.initMap();
    }
};
</script>
<style lang="less" scoped>
.driver-map-dialog .BMap_stdMpPan {
    display: block !important;
}
.driver-map-dialog .BMap_stdMpZoom {
    top: 50px;
}

#mapContainer {
    height: 70vh;
    width: 76vw;
    background-color: #fff;
}
</style>
